module.exports = __webpack_public_path__ + "static/media/engineeringIcon.1d1dff4c.svg";